// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-safety-confirm-to-other-user-confirm #group-name,#send-safety-confirm-to-other-user-confirm #opening-sentence,#send-safety-confirm-to-other-user-confirm #questions{white-space:pre-wrap;word-wrap:break-word}#send-safety-confirm-to-other-user-confirm .back-btn,#send-safety-confirm-to-other-user-confirm .send-btn{min-width:84px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
